import tar from '../assets/execs/Tar.jpg'
import anfield from '../assets/execs/Anfield.jpg'
import prim from '../assets/execs/Prim.jpg'
import ploy from '../assets/execs/Ploy.jpg'
import miu from '../assets/execs/Miu.jpg'
import tiger from '../assets/execs/Tiger.jpg'


export const exec = [
    {
        name: 'Tar',
        fullName: 'Nithit Kongsuphol',
        position: 'Vice-President',
        course: 'BEng Systems Engineerin',
        email: 'nithit.kongsuphol@warwick.ac.uk',
        img: tar
    },
    {
        name: 'Anfield',
        fullName: 'Pannavich Anchananon',
        position: 'Outreach',
        course: 'BSc Management',
        email: 'pannavich.anchananon@warwick.ac.uk',
        img: anfield
    },
    {
        name: 'Prim',
        fullName: ' Prim Malakul',
        position: 'Treasurer',
        course: 'BSc Accounting and Finance',
        email: 'prim.malakul@warwick.ac.uk',
        img: prim
    },
    {
        name: 'Ploy',
        fullName: 'Thiracha Kasemkiatsakul',
        position: 'Marketing',
        course: 'BASc Global Sustainable Development and Business Studies',
        email: 'ploy.kasemkiatsakul@warwick.ac.uk',
        img: ploy
    },
    {
        name: 'Miumiu',
        fullName: 'Aonrumpa Assavatavawich',
        position: 'Operation',
        course: 'BSc Economics',
        email: 'aonrumpa.assavatavawich@warwick.ac.uk',
        img: miu
    },
    {
        name: 'Tiger',
        fullName: 'Pattarapon Intalap',
        position: 'Operation',
        course: 'BSc Economics',
        email: 'tiger.intalap@warwick.ac.',
        img: tiger
    }
]

